import styled from "styled-components";

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
  box-sizing: border-box;
  border: 6px solid #0D4179;
`